import { useState } from "react"
import { sortArray } from "../utils/ArrayUtils"

export enum SortDirection {
	ASC = "ASC",
	DESC = "DESC",
}
const useSort = <T>(defaultProperty: string, defaultDirection = SortDirection.ASC) => {
	const [sortProperty, setSortProperty] = useState(defaultProperty)
	const [sortDirection, setSortDirection] = useState<SortDirection>(defaultDirection)
	const sortBy = (newSortProperty: string, newSortDirection?: SortDirection) => {
		// if the direction is specified, then use it
		if (newSortDirection != null) {
			setSortProperty(newSortProperty)
			setSortDirection(newSortDirection)
			return
		}
		// if the direction is not specified, reverse direction if the property is the same
		if (newSortProperty === sortProperty) {
			setSortDirection(sortDirection === SortDirection.ASC ? SortDirection.DESC : SortDirection.ASC)
			return
		}
		// if the property is new, use it and reset the direction to ASC
		setSortProperty(newSortProperty)
		setSortDirection(SortDirection.ASC)
	}
	const sort = (array: T[]) => sortArray(array, sortProperty, sortDirection)
	return { sortProperty, sortDirection, sortBy, sort }
}
export default useSort
